import { forwardRef } from 'react';
import styles from './legend.module.css';
import clsx from 'clsx';

export type LegendProps = React.ComponentPropsWithoutRef<'legend'>;
const LegendComp = (
  { className, ...rest }: LegendProps,
  ref: React.ForwardedRef<HTMLLegendElement>
) => {
  return (
    <legend className={clsx(styles.legend, className)} ref={ref} {...rest} />
  );
};

export const Legend = forwardRef<HTMLLegendElement, LegendProps>(LegendComp);

Legend.displayName = 'Legend';
